import { ca } from '@cian/analytics';

import { getSurveyAnalyticsParams } from './getSurveyAnalyticsParams';
import { IMakeHandlerParams } from './types';

export function makeClickHandler(params: IMakeHandlerParams) {
  const category = 'Card';

  const preparedParams = Object.assign(
    getSurveyAnalyticsParams({
      ...params,
      category,
    }),
    {
      action: 'click',
      label: 'offer_analytics_with_poll',
    },
  );

  return (onCustomEvent: () => void) => () => {
    if (onCustomEvent) {
      onCustomEvent();
    }

    ca('eventSite', preparedParams);
  };
}
